// extracted by mini-css-extract-plugin
module.exports = {"teaser":"ProductContent_teaser__b1SHv"};